import React from 'react'
import 'moment/locale/pt-br'
import Select from 'react-select'
import Datetime from 'react-datetime'
import 'react-select/dist/react-select.css'
import 'react-datetime/css/react-datetime.css'
import { FormControl, ControlLabel } from 'react-bootstrap'

const _renderError = error => {
    if (error) return <small className='form__error'>{error}</small>
}

export const renderField = ({ input, label, placeholder, type, optional, disabled, meta: { touched, error } }) => (
    <div className='form__field'>
        <ControlLabel className='form__label'>
            {label}
            {optional ? <small className='form__optional'>&nbsp;&nbsp;Opcional</small> : null}
        </ControlLabel>
        <FormControl {...input} disabled={disabled} placeholder={placeholder} type={type} />
        {touched && _renderError(error)}
    </div>
)

export const renderTextarea = ({ input, label, optional, disabled, meta: { touched, error } }) => (
    <div className='form__field'>
        <ControlLabel className='form__label'>
            {label}
            {optional ? <small className='form__optional'>&nbsp;&nbsp;Opcional</small> : null}
        </ControlLabel>
        <FormControl className='form__textarea' {...input} componentClass='textarea' style={{ height: 250 }} />
        {touched && _renderError(error)}
    </div>
)

export const renderFileInputField = ({ input, label, type, disabled, meta: { touched, error } }) => (
    <div className='form__field'>
        <ControlLabel className='form__label'>{label}</ControlLabel>
        <FormControl
            {...input} disabled={disabled} type={type} />
        {touched && _renderError(error)}
    </div>
)

export const renderTimePicker = ({ input, label, optional, placeholder, meta: { touched, error } }) => (
    <div className='form__field'>
        <ControlLabel className='form__label'>{label}</ControlLabel>
        {optional ? <small className='form__optional'>&nbsp;&nbsp;Opcional</small> : null}
        <Datetime
            {...input}
            dateFormat={false}
            inputProps={{ placeholder: placeholder || 'Selecione o horário' }}
            onChange={input.onChange}
        />
        {touched && _renderError(error)}
    </div>
)

export const renderDatePicker = ({ input, label, optional, placeholder, meta: { touched, error } }) => (
    <div className='form__field'>
        <ControlLabel className='form__label'>{label}</ControlLabel>
        {optional ? <small className='form__optional'>&nbsp;&nbsp;Opcional</small> : null}
        <Datetime
            locale='pt-br'
            {...input}
            timeFormat={false}
            inputProps={{ placeholder: placeholder || 'Selecione a data' }}
            onChange={input.onChange}
        />
        {touched && _renderError(error)}
    </div>
)

export const renderSelect = ({ input, label, placeholder, disabled, optional, options, meta: { touched, error } }) => (
    <div className='form__field'>
        <ControlLabel className='form__label'>
            {label}
            {optional ? <small className='form__optional'>&nbsp;&nbsp;Opcional</small> : null}
        </ControlLabel>
        <Select
            style={{ height: 40 }}
            {...input}
            options={options}
            disabled={disabled}
            placeholder={placeholder}
            onChange={input.onChange}
            onBlur={() => input.onBlur(input.value)}
        />
        {touched && _renderError(error)}
    </div>
)


// WEBPACK FOOTER //
// ./src/forms/_fieldRenderer.jsx